export const constants = {
  NEW_UNIVERSAL_COOKIE: 'NewUniversalCookie',

  EVENT_TRACKER: {
    PAGE_TITLE: 'Contact-Us'
  },
  // BRAND
  RETAIL: 'retail',
  SBBI: 'sbbi',
  currencyCode: 'GBP',

  // FOOTER LINKS
  ONLINE_BANKING_GUARANTEE: 'Online Banking Guarantee',
  SITE_HELP_ACCESSIBILITY: 'Accessibility',
  SECURITY_PRIVACY: 'Security & Privacy',
  TERMS_CONDITIONS: 'Terms & Conditions',
  LEGAL: 'Legal',
  NO_PAYEE:
    'There are no payees listed on this account. Select another account to make a payment from',

  // APIs
  CHANNEL: 'INT',
  XAPIVERSION: '2',
  SCOPE: 'payments.read',
  V10: 'v10',
  // DOMAINS
  retailDomains: ['retail', 'rint'],
  sbbiDomains: ['business', 'sbbi'],
  cahootDomains: ['cahoot'],

  shadowDomains: ['shadow.secure.cahoot.com', 'shadow.retail.santander.co.uk'],
  pilotDomains: ['pilot-secure.cahoot.pre.corp',
    'retailpilotl.santanderuk.pre.corp',
    'shadow.secure.cahoot.com',
    'shadow.retail.santander.co.uk'],

  // Adobe contents
  ADOBE_PRIVATE_BANKING: 'Private-Banking',
  ADOBE_SELECT: 'Select',
  ADOBE_MASS_MARKET: 'Mass-Market',

  // Brands and Segments
  ADOBE: 'adobeAnalytics',
  ADOBE_PAGE_VIEW: 'pageView',
  ADOBE_TRACK_LINK: 'trackAction',
  ADOBE_TRACK_ERROR: 'trackSystemError',
  ADOBE_TRACK_ERROR_VALIDATION: 'trackValidationError',
  BRAND_SBBI: 'sbbi',
  BRAND_RETAIL: 'retail',
  BRAND_CAHOOT: 'cahoot',
  SEGMENT_MASS_MARKET: 'm-m',
  SEGMENT_SELECT: 'select',
  SEGMENT_PRIVATE_BANKING: 'private-banking',
  SANTANDER_LOGO_PNG: 'santander_logo.png',
  SANTANDER_LOGO_SVG: 'santander_logo.svg',
  SANTANDER_LOGO_TXT: 'santander-logo',

  ADOBE_SEGMENT_MAP: new Map()
    .set('personal', 'mass market')
    .set('select', 'select')
    .set('private', 'private'),

  // LaunchDarkly
  thirdpartyAdobeEnabled:'thirdparty-adobe-olb-enabled'
};
